import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestConfiguracaoAlarmeTanques({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'configuracaoalarmetanques', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `configuracaoalarmetanques/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'configuracaoalarmetanques', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/configalarmetanques');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'configuracaoalarmetanques', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@configuracaoalarmetanque/CONFIGURACAOALARMETANQUES_IN_REQUEST',
    requestConfiguracaoAlarmeTanques
  ),
  takeLatest(
    '@configuracaoalarmetanque/SUCCESS_REMOVE',
    requestConfiguracaoAlarmeTanques
  ),
  takeLatest('@configuracaoalarmetanque/FIND_CONFIGURACAOALARMETANQUE', find),
  takeLatest(
    '@configuracaoalarmetanque/UPDATE_CONFIGURACAOALARMETANQUE',
    update
  ),
  takeLatest('@configuracaoalarmetanque/RECORD_FILTERING', applyedFilters),
  takeLatest('@configuracaoalarmetanque/RESET_FILTERING', applyedFilters),
]);
